import {
    OrderDeliveryTypeDto,
    OrderPaymentTypeDto,
    OrderStatusDto,
} from "services/orders/restModels";

/*
* Подписи справочников заказа. Реестр констант на бэке (GET /constants) их не отдаёт: статусов
* заказа там нет вовсе, а в orderPaymentDetailsTypes нет СБП и лежат технические
* названия вида «CloudPayments Checkout».
* */
export const ORDER_STATUS_LABELS: { [key in OrderStatusDto]: string } = {
    [OrderStatusDto.preorder]: "Предзаказ",
    [OrderStatusDto.new]: "Новый",
    [OrderStatusDto.accepted]: "Принят",
    [OrderStatusDto.canceled]: "Отменён",
    [OrderStatusDto.canceledWithRefund]: "Отменён с возвратом денег",
    [OrderStatusDto.sentToKitchen]: "Отправлен на кухню",
    [OrderStatusDto.canceledByKitchen]: "Отменён кухней",
    [OrderStatusDto.acceptedByKitchen]: "Передан на кухню",
    [OrderStatusDto.ready]: "Готов",
    [OrderStatusDto.givenOut]: "Отдан",
    [OrderStatusDto.givenOutToDelivery]: "Отдан в доставку",
    [OrderStatusDto.readyToPickUp]: "Готов к выдаче",
    [OrderStatusDto.finished]: "Завершён",
    [OrderStatusDto.paid]: "Оплачен",
};

export const ORDER_DELIVERY_TYPE_LABELS: { [key in OrderDeliveryTypeDto]: string } = {
    [OrderDeliveryTypeDto.toTable]: "Заказ к столу",
    [OrderDeliveryTypeDto.insideTheRestaurant]: "Внутри заведения",
    [OrderDeliveryTypeDto.toAddress]: "Доставка",
    [OrderDeliveryTypeDto.takeAway]: "На вынос",
    [OrderDeliveryTypeDto.takeAwayToTime]: "Самовывоз ко времени",
    [OrderDeliveryTypeDto.toVehicle]: "До машины",
};

export const ORDER_PAYMENT_TYPE_LABELS: { [key in OrderPaymentTypeDto]: string } = {
    [OrderPaymentTypeDto.cloudPayments]: "Онлайн-эквайринг CloudPayments",
    [OrderPaymentTypeDto.sbpTochka]: "СБП",
    [OrderPaymentTypeDto.offline]: "Официанту/курьеру при получении",
    [OrderPaymentTypeDto.bankCard]: "Переводом на карту",
    [OrderPaymentTypeDto.companyInvoice]: "На расчётный счёт",
};

/*
* Фильтровать можно по трём статусам. Остальные одиннадцать в кабинете не выбираются: часть
* проставляется кухней и интеграцией, часть (Preorder, Paid) устарела. Приходить у заказов они
* продолжают и подпись в колонке статуса получают из карты выше — узкий здесь именно список
* фильтра, а не набор значений. Порядок — по ходу жизни заказа.
* */
export const ORDER_STATUS_FILTER_OPTIONS: OrderStatusDto[] = [
    OrderStatusDto.new,
    OrderStatusDto.accepted,
    OrderStatusDto.canceled,
];

export const ORDER_DELIVERY_TYPE_FILTER_OPTIONS: OrderDeliveryTypeDto[] = [
    OrderDeliveryTypeDto.toTable,
    OrderDeliveryTypeDto.insideTheRestaurant,
    OrderDeliveryTypeDto.toAddress,
    OrderDeliveryTypeDto.takeAway,
    OrderDeliveryTypeDto.takeAwayToTime,
    OrderDeliveryTypeDto.toVehicle,
];

// Перевод на карту и оплата по счёту в фильтре не нужны — как и статусы выше, подпись в
// колонке они получают, а отбирать по ним заказы кабинет не просит.
export const ORDER_PAYMENT_TYPE_FILTER_OPTIONS: OrderPaymentTypeDto[] = [
    OrderPaymentTypeDto.cloudPayments,
    OrderPaymentTypeDto.sbpTochka,
    OrderPaymentTypeDto.offline,
];

export const orderStatusLabel = (status: OrderStatusDto) => ORDER_STATUS_LABELS[status] || status;

export const orderDeliveryTypeLabel = (type: OrderDeliveryTypeDto) =>
    ORDER_DELIVERY_TYPE_LABELS[type] || type;

export const orderPaymentTypeLabel = (type: OrderPaymentTypeDto) =>
    ORDER_PAYMENT_TYPE_LABELS[type] || type;
